import { getCachedMe } from "../../utils/auth-storage.js"
import { reloadThePage } from "../../login/login.js"
import { hostAppCall } from "../../utils/appFunctions.js"
import { PATH } from "../helpers/shared-record-path.js"
import app from "../../utils/app.js"
window.hostAppCall = hostAppCall
import initLayout from "./init-layout.js"
if (!window.WEBVIEW01) window.WEBVIEW01 = {}

app.saveAppInfoInCookie()
const pathType = PATH.getCurrentPathType()
pathType.init()

document.addEventListener("DOMContentLoaded", () => {
    initLayout()
})

// Note: this will reload the /records page when the user is signed in or out from another page. 
// Otherwise the records page does not know about current updated user
let lastcachedMe = getCachedMe()
document.addEventListener("visibilitychange", () => {
    const cachedMe = getCachedMe()
    if (cachedMe && lastcachedMe && cachedMe.user.sessionId === lastcachedMe.user.sessionId) return
    lastcachedMe = cachedMe
    requestAnimationFrame(() => reloadThePage())
})

